module.exports = __webpack_public_path__ + "static/media/check-white.f1e19375.svg";